import { Component, OnInit } from "@angular/core";
import { SessionStateService } from "../../../../core/services/session-state.service";
import { HOUSE_TARIFF } from "../../../../entities/houses/houses.constants";
import { Observable } from "rxjs";
import {
  GROUP,
  DeviceType,
} from "../../../../entities/devices/devices.constant";
import { DevicesService } from "../../../../entities/devices/devices.service";
import { SchedulingType } from "../../../../entities/scheduling/scheduling.constants";
import { HOUSE_COUNTRIES } from "../../../../entities/houses/houses.constants";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-coachmark-scheduling",
  templateUrl: "./coachmark-scheduling.component.html",
  styleUrls: ["./coachmark-scheduling.component.scss"],
})
export class CoachmarkSchedulingComponent implements OnInit {
  economicExcluded: boolean;
  selectedTab = 1;
  show: boolean;
  setpointExcluded: boolean;
  menu: any[];
  constructor(
    private sessionStateService: SessionStateService,
    private devicesService: DevicesService
  ) {}

  ngOnInit() {
    this.show = true;
    this.checkSetPointExclusion();
    this.checkEconomicExclusion();
    const loadPosition = setInterval(() => {
      const position: ClientRect = this.getElementsPositions();
      if (position !== undefined) {
        if ($("#coachmarkScheduling").length === 1) {
          $("#coachmarkScheduling").css("top", position.top - 20);
          $("#coachmarkScheduling").css("left", position.left);
          $("#coachmarkScheduling").css("visibility", "visible");
        }
        clearInterval(loadPosition);
      }
    }, 500);
  }

  skipHelpTips() {
    this.show = false;
    this.sessionStateService.setCoachMarkIndividualState(
      this.sessionStateService
        .getCoachMarkIndividualState()
        .set("scheduling", false)
    );
  }

  nextTab() {
    if (this.selectedTab < 5) {
      if (this.selectedTab < 4) {
        if (this.economicExcluded && this.setpointExcluded) {
          if (this.selectedTab < 3) {
            this.selectedTab++;
          } else {
            this.skipHelpTips();
          }
        } else if (this.economicExcluded || this.setpointExcluded) {
          this.selectedTab++;
        } else {
          this.selectedTab++;
        }
      } else {
        if (this.economicExcluded || this.setpointExcluded) {
          this.skipHelpTips();
        } else if (!this.economicExcluded && !this.setpointExcluded) {
          this.selectedTab++;
        }
      }
    } else {
      this.skipHelpTips();
    }
    const position: ClientRect = this.getElementsPositions();
    if ($("#coachmarkScheduling").length === 1) {
      $("#coachmarkScheduling").css("top", position.top - 20);
      $("#coachmarkScheduling").css("left", position.left);
    }
  }

  checkEconomicExclusion() {
    if (
      (this.sessionStateService.getHouseTariff() &&
        this.sessionStateService.getHouseTariff().tariff ===
          HOUSE_TARIFF.SIMPLE) ||
      this.sessionStateService.getHouse().country === HOUSE_COUNTRIES.SPAIN
    ) {
      this.economicExcluded = true;
    } else {
      this.economicExcluded = false;
    }
  }

  checkSetPointExclusion() {
    const excludedtabs = [];
    this.devicesService
      .getHouseModulesByGroups(
        this.sessionStateService.getHouse().houseId,
        DeviceType.CLIMATIZATION,
        undefined,
        [GROUP.HVAC, GROUP.THERMOSTAT]
      )
      .catch((e: any) => of(false))
      .finally(
        () =>
          (this.menu = Object.values(SchedulingType)
            .filter((k) => excludedtabs.indexOf(k) === -1)
            .map((k) => k.toLowerCase().replace(new RegExp("_", "g"), " ")))
      )
      .subscribe(
        (hasSetPoint) => {
          if (hasSetPoint) {
            this.setpointExcluded = false;
          } else {
            this.setpointExcluded = true;
          }
        },
        (err) => {
          this.setpointExcluded = true;
        }
      );
  }

  getIconImg() {
    switch (this.selectedTab) {
      case 1:
        return "coachmark-sheduling-on-off";
      case 2:
        if (this.economicExcluded) {
          return "coachmark-sheduling-standby-killer";
        } else {
          return "coachmark-sheduling-economic";
        }
      case 3:
        if (this.economicExcluded) {
          if (this.setpointExcluded) {
            return "coachmark-sheduling-power-limit-control";
          } else {
            return "coachmark-sheduling-setpoint";
          }
        } else {
          return "coachmark-sheduling-standby-killer";
        }
      case 4:
        if (this.economicExcluded) {
          return "coachmark-sheduling-power-limit-control";
        } else {
          if (this.setpointExcluded) {
            return "coachmark-sheduling-power-limit-control";
          } else {
            return "coachmark-sheduling-setpoint";
          }
        }
      case 5:
        return "coachmark-sheduling-power-limit-control";
    }
  }

  getText() {
    switch (this.selectedTab) {
      case 1:
        return "Define the start and <br> the end of the schedule";
      case 2:
        if (this.economicExcluded) {
          return "Control the consumption of the <br> devices in standby mode";
        } else {
          return "Schedule the working period of your <br> devices according to your tariff";
        }
      case 3:
        if (this.economicExcluded) {
          if (this.setpointExcluded) {
            return "Control the cut-off power to avoid <br> your electrical switchboard from tripping";
          } else {
            return "Control the operation of your Air Conditioner";
          }
        } else {
          return "Control the consumption of the <br> devices in standby mode";
        }
      case 4:
        if (this.economicExcluded) {
          return "Control the cut-off power to avoid <br> your electrical switchboard from tripping";
        } else {
          if (this.setpointExcluded) {
            return "Control the cut-off power to avoid <br> your electrical switchboard from tripping";
          } else {
            return "Control the operation of your Air Conditioner";
          }
        }
      case 5:
        return "Control the cut-off power to avoid <br> your electrical switchboard from tripping";
    }
  }

  getElementsPositions() {
    const navElems = document.getElementsByClassName("nav-link");
    if (navElems[this.selectedTab - 1]) {
      return navElems[this.selectedTab - 1].getBoundingClientRect();
    } else {
      return undefined;
    }
  }

  getBtnText() {
    if (
      this.selectedTab > 4 ||
      (this.selectedTab === 4 && this.economicExcluded)
    ) {
      return "GOT IT!";
    } else {
      return "NEXT!";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/coachmark-scheduling/coachmark-scheduling.component.ts